export default {
	searchParam: {
		mstCd: 'ALL',
		regId: '',
		mstCdName: '',
		useYn: 'ALL'
	},
	taskCommCdMstPagingInfo: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	taskCommCdPagingInfo: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	pageArray: [10, 30, 50, 100],
	taskCommCdRows: [],
	taskCommCdMstRows: [],
	taskCommCdMstOptions: [],
	useYnOptions: [],
	currentMstCd: ''
};
